import React, { useEffect } from 'react'

// Utils
import { getItem, setItem } from 'utils/localStorage'
import { parseSafariUserAgent } from 'utils/userAgent'

// Constants
import localStorageKeys from 'constants/localStorageKeys'

// Components
import { useToast } from 'containers/ToastManager'
import { CANVAS_VIEW_BETA_DOCS } from 'modules/shares/PageCanvasView/constants'

// Helpers
const storageKey = localStorageKeys['safariGPUWarning']

/**
 * Shows a warning to users of browsers with a known performance issue that
 * affects the Web Renderer. Warning is shown only once per affected browser
 * version to avoid spamming the user.
 *
 * @see https://bugs.webkit.org/show_bug.cgi?id=227408
 * @see https://bugs.webkit.org/show_bug.cgi?id=231012
 */
export const useSafariGPUWarning = () => {
  const { showToast } = useToast()

  useEffect(() => {
    const safariUA = parseSafariUserAgent()
    const safariVersion = `${safariUA?.version.major}.${safariUA?.version.minor}.${safariUA?.version.patch}`

    const safariGPUWarning =
      safariUA !== null &&
      safariUA.hardware === 'Macintosh' &&
      ((safariUA.version.major >= 14 && safariUA.version.minor >= 1) ||
        safariUA.version.major >= 15)

    if (!safariGPUWarning) return

    const warningSeenForVersion = getItem(storageKey) === safariVersion

    if (warningSeenForVersion) return

    setItem(storageKey, safariVersion)

    showToast(
      <>
        Canvas performance on Safari is degraded by a{' '}
        <a href={CANVAS_VIEW_BETA_DOCS}>known issue</a>
      </>,
      'default',
      false
    )
  }, [showToast])
}
